import { render, staticRenderFns } from "./e-form-group.vue?vue&type=template&id=2e54d42a"
import script from "./e-form-group.vue?vue&type=script&lang=js"
export * from "./e-form-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports